module.exports = __webpack_public_path__ + "img/ylb-logo.f1a0cd23.png";